import { Route, Switch } from 'react-router';
import CreateDisciplineGroup from './create';
import EditDisciplineGroup from './edit';
import ViewDisciplineGroups from './view';

const DisciplineGroups = () => {
  return (
    <Switch>
      <Route exact path='/admin/disciplines/groups' component={ViewDisciplineGroups} />
      <Route exact path='/admin/disciplines/groups/new' component={CreateDisciplineGroup} />
      <Route exact path='/admin/disciplines/groups/:id' component={EditDisciplineGroup} />
    </Switch>
  );
};

export default DisciplineGroups;
